module.exports = {
      id: "icons:envelope-usage",
      viewBox: "0 0 17 15",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#icons:envelope-usage",
      toString: function () {
        return this.url;
      }
    }